/**
 * Payment-method logos row shown in the cart just above the checkout CTA.
 * Pure SVG so there's no image load wait. Monochrome dark-grey marks on
 * light pill backgrounds so they read as "legit" without screaming.
 */
const Pill = ({ children, label }) => (
  <span
    aria-label={label}
    title={label}
    className="flex h-7 w-11 items-center justify-center rounded-md border border-tracksy-ink/10 bg-white px-1.5"
  >
    {children}
  </span>
);

export default function PaymentLogos() {
  return (
    <div className="flex items-center justify-center gap-1.5" data-testid="cart-payment-logos">
      <Pill label="Visa">
        <svg viewBox="0 0 48 16" className="h-3.5 w-auto" fill="#1a1f71">
          <text x="0" y="13" fontFamily="Arial Black, Arial, sans-serif" fontSize="14" fontWeight="900" letterSpacing="-0.5">VISA</text>
        </svg>
      </Pill>
      <Pill label="Mastercard">
        <svg viewBox="0 0 36 22" className="h-4 w-auto">
          <circle cx="13" cy="11" r="9" fill="#eb001b" />
          <circle cx="23" cy="11" r="9" fill="#f79e1b" fillOpacity="0.9" />
        </svg>
      </Pill>
      <Pill label="American Express">
        <svg viewBox="0 0 36 16" className="h-3.5 w-auto">
          <rect width="36" height="16" rx="2" fill="#2e77bb" />
          <text x="4" y="12" fontFamily="Arial Black, Arial, sans-serif" fontSize="9" fontWeight="900" fill="#fff">AMEX</text>
        </svg>
      </Pill>
      <Pill label="Apple Pay">
        <svg viewBox="0 0 36 16" className="h-3.5 w-auto" fill="#111">
          <path d="M7.6 4.6a2.3 2.3 0 0 1-1.4-.5 2.1 2.1 0 0 1 1-.6c.1.5-.1 1-.3 1.3zm1.1 1.1c-.6 0-1.2.4-1.5.4s-.8-.4-1.3-.4c-.7 0-1.3.4-1.6 1-.7 1.2-.2 3 .5 4 .3.4.7.9 1.2.9s.7-.3 1.2-.3.8.3 1.3.3.8-.4 1.1-.9c.2-.3.4-.7.5-1-.1 0-1-.4-1-1.5s.8-1.4.8-1.5c-.2-.6-.9-1-1.2-1z" />
          <text x="13" y="12" fontFamily="Arial, sans-serif" fontSize="9" fontWeight="700">Pay</text>
        </svg>
      </Pill>
      <Pill label="Google Pay">
        <svg viewBox="0 0 36 16" className="h-3.5 w-auto">
          <text x="2" y="12" fontFamily="Arial, sans-serif" fontSize="9" fontWeight="700">
            <tspan fill="#4285f4">G</tspan>
            <tspan fill="#ea4335">o</tspan>
            <tspan fill="#fbbc04">o</tspan>
            <tspan fill="#4285f4">g</tspan>
            <tspan fill="#34a853">l</tspan>
            <tspan fill="#ea4335">e</tspan>
            <tspan fill="#111"> Pay</tspan>
          </text>
        </svg>
      </Pill>
      <Pill label="Shop Pay">
        <svg viewBox="0 0 36 16" className="h-3.5 w-auto">
          <rect width="36" height="16" rx="2" fill="#5a31f4" />
          <text x="3" y="12" fontFamily="Arial Black, Arial, sans-serif" fontSize="9" fontWeight="900" fill="#fff">Shop</text>
        </svg>
      </Pill>
    </div>
  );
}
